import { FC, useMemo } from "react";
import { TimeEntryCategory } from "@myapp/contract";
import Select from "../../../shared/ui/controls/Select/Select";
import { timeEntryCategoryOptions } from "../model/timeEntryCategory";
import { ISelectOption } from "../../../shared/types/ISelectOption";

const ALL_OPTION: ISelectOption = { value: null, label: "Alle Kategorien" };

interface TimeEntryCategorySelectProps {
  value?: TimeEntryCategory | null;
  onChange?: (value: TimeEntryCategory | null) => void;
  withAllOption?: boolean;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  error?: string | null;
  size?: "md" | "sm";
}

const TimeEntryCategorySelect: FC<TimeEntryCategorySelectProps> = ({
  value,
  onChange,
  withAllOption = false,
  placeholder = "Kategorie wählen",
  className,
  disabled,
  error,
  size,
}) => {
  const options = useMemo(
    () => (withAllOption ? [ALL_OPTION, ...timeEntryCategoryOptions] : timeEntryCategoryOptions),
    [withAllOption],
  );

  return (
    <Select
      options={options}
      value={value ?? null}
      onChange={(v) => onChange?.(v as TimeEntryCategory | null)}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      error={error}
      size={size}
    />
  );
};

export default TimeEntryCategorySelect;
